import { faAddressBook, faBicycle, faMobile } from '@fortawesome/free-solid-svg-icons'
import {
  faCcMastercard,
  faFacebook,
  faInstagram,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons'
import { getShopConfiguration, socialUsernameRegex } from '../lib/utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { NextSeo } from 'next-seo'
import PlacePicker from '../components/PlacePicker'
import SectionIcon from '../components/SectionIcon'

const iconMap = {
  facebook: faFacebook,
  instagram: faInstagram,
  twitter: faTwitter,
}

export default function About({ shop, config }) {
  return (
    <>
      <NextSeo title="About us" />
      <div className="container py-3">
        <div className="row">
          <div className="col-lg-3" />
          <div className="col-lg-6">
            <div
              className="w-full rounded bg-light ratio ratio-21x9"
              style={{ backgroundImage: `url(${shop.banner?.url || ''})`, backgroundSize: 'cover' }}
            />

            <div className="d-flex my-3">
              <div
                className="cursor-pointer bg-light me-3"
                style={{
                  backgroundImage: `url(${shop.logo?.url || ''})`,
                  backgroundSize: 'cover',
                  height: 90,
                  width: 90,
                }}
              />
              <div className="flex-fill">
                <h4 className="h4 mb-0">{shop.title}</h4>
                <p className="text-muted">{shop.tagline}</p>
              </div>
            </div>

            <div className="mb-5 d-flex flex-wrap">
              {(shop.socials || []).map((social) => {
                const usernameMatch = social.url.match(socialUsernameRegex)

                return (
                  <div key={social.url} className="mb-1 d-inline me-3">
                    <a
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary text-nowrap"
                    >
                      <FontAwesomeIcon size="lg" icon={iconMap[social.site]} className="me-2" />{' '}
                      <span className="text-muted">{usernameMatch[1]}</span>
                    </a>
                  </div>
                )
              })}
            </div>

            <p className="text-muted mb-0">About us</p>
            <p className="whitespace-pre">{shop.about}</p>

            <div className="d-flex mt-5">
              <div className="me-3">
                <SectionIcon icon={faAddressBook} className="text-secondary bg-secondary-light" />
              </div>

              <div>
                <h6 className="h6">Contact &amp; Address</h6>
                <p>
                  {shop.contact?.phone} <br />
                  {shop.contact?.email}
                </p>
              </div>
            </div>
            <div className="w-100">
              {shop.address ? (
                <div>
                  <PlacePicker
                    onSelectAddress={() => {}}
                    label={shop.title}
                    address={shop.address}
                    displayOnly
                    disableGesture={true}
                  />

                  <p className="mt-3">
                    {shop.address.street} <br />
                    {shop.address.region}
                  </p>

                  <p>
                    <a
                      className="btn btn-secondary text-white"
                      target="_blank"
                      href={`https://www.google.com/maps/dir/?api=1&destination=${shop.address.gps.coordinates[0]},${shop.address.gps.coordinates[1]}`}
                      rel="noreferrer"
                    >
                      Get Directions
                    </a>
                  </p>
                </div>
              ) : (
                <div>
                  <span className="text-muted">Address not set.</span>
                </div>
              )}
            </div>

            <p className="text-muted mt-5 mb-0">Returns &amp; Refund Policy</p>
            {config.returnsAndRefund?.allowed ? (
              <>
                <p>We allow returns and refunds based on the following terms:</p>
                <p className="whitespace-pre">{config.returnsAndRefund.terms}</p>
              </>
            ) : (
              <p>We do not allow returns nor refunds.</p>
            )}

            <div className="d-flex mt-5">
              <div className="me-3">
                <SectionIcon icon={faMobile} className="text-secondary bg-secondary-light" />
              </div>

              <div>
                <h6 className="h6">Payment</h6>
                <p>
                  We accept all payments online. You can pay with the following payment providers:
                </p>

                <ul className="list-unstyled">
                  <li>MTN Mobile Money</li>
                  <li>Vodafone Cash</li>
                  <li>AirtelTigo Money</li>
                  <li>
                    <FontAwesomeIcon icon={faCcMastercard} className="text-secondary" />{' '}
                    Mastercard/VISA
                  </li>
                </ul>

                <p className="text-muted">Payment is requested at checkout.</p>
              </div>
            </div>

            <div className="d-flex mt-5">
              <div className="me-3">
                <SectionIcon icon={faBicycle} className="text-secondary bg-secondary-light" />
              </div>

              <div>
                <h6 className="h6">Delivery</h6>
                <p>
                  Delivery is calculated based on your location provided during checkout. If your
                  location is not supported please contact us via our socials or contact
                  number/email before placing your order.
                </p>
                {config.allowPickups ? (
                  <p className="alert-secondary alert p-1">We allow pick-ups from our shop.</p>
                ) : (
                  <p className="alert-danger alert p-1">Pick-ups from our shop are not allowed.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export async function getServerSideProps({ req }) {
  return await getShopConfiguration(req.locals.config.shop)
}
